// Maps each /onboarding/* mirror route to the production route family it
// mirrors, so the mirror sidebars can reuse the production active-state rules
// (checkIsActive / isActiveButton) unchanged. Without this, no nav item ever
// shows as selected during the tours — the production path lists can't match
// an /onboarding/... pathname. Mirror-only; production matching code is
// untouched (SidebarSwitcher never mounts the mirror components off
// /onboarding/*).
const EXACT_ALIASES = {
  // The mirror Marking page shows the rubrics list — production /tools/rubrics.
  '/onboarding/marking': '/tools/rubrics',
  // Production create-task route is /tasks/new.
  '/onboarding/new-task': '/tasks/new',
};

export const toProductionPath = (pathname = '') => {
  const cleanPath = pathname.split('?')[0].split('#')[0];
  if (!cleanPath.startsWith('/onboarding/')) return cleanPath;
  if (EXACT_ALIASES[cleanPath]) return EXACT_ALIASES[cleanPath];
  // The rest of the mirror tree shadows production 1:1
  // (/onboarding/tools/*, /onboarding/documents/:id, /onboarding/submissions/:id).
  return cleanPath.slice('/onboarding'.length);
};
